import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import ActionButton from "../../../../../Components/Buttons/ActionButton";

const CollapsibleFormSection = (props) => {

    const handleExpand = (evt) => {
        props.onChangeCollapsed(true);
    }

    const handleCollapse = (evt) => {
        props.onChangeCollapsed(false);
    }

    const handleDelete = (evt) => {
        props.onDelete(evt, props.index);
    }

    if (props.isCollapsed) {
        return (
            <div className={`form-group ${props.className} collapsed`}>
                <div className="visitor-summary-row grid-x grid-margin-x">
                    <div className="cell small-4 summary-name overflow-x-ellipsis">
                        {!props.name && (
                            <span style={{color: 'red'}}>
                                Unnamed
                            </span>
                        )}
                        {props.name}
                    </div>
                    <div className="cell small-6">
                        {Object.keys(props.details).map((key, index, array) => <React.Fragment key={key}>
                            {props.details[key]}
                            {index < array.length - 1 && <>&nbsp;&nbsp;&nbsp;</>}
                        </React.Fragment>)}
                    </div>
                    <div className="cell small-2">
                        <div className="button-group small align-right">
                            <ActionButton
                                icon="fa-pencil"
                                onClick={handleCollapse}
                            />
                            <ActionButton
                                icon="fa-trash" className="primary"
                                onClick={handleDelete}
                                isDisabled={!props.onDelete}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (props.hideButtons) {
        return (
            <div className={`form-group ${props.className}`}>
                {props.children}
            </div>
        );
    } else {
        return (
            <div className={`form-group ${props.className}`}>
                <div className="button-group form-group-button-group small">
                    <ActionButton
                        icon="fa-minus"
                        onClick={handleExpand}
                    />
                    <ActionButton
                        icon="fa-trash"
                        className=""
                        onClick={handleDelete}
                        isDisabled={!props.onDelete}
                    />
                </div>

                {props.children}
            </div>
        );
    }
}

CollapsibleFormSection.propTypes = {
    index: PropTypes.any,
    details: PropTypes.array,
    name: PropTypes.string,
    onChangeCollapsed: PropTypes.func,
    onDelete: PropTypes.func,
    isCollapsed: PropTypes.bool,
    hideButtons: PropTypes.bool,
    className: PropTypes.string
}

export default CollapsibleFormSection;
